var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Modal, TextHeading, Button, useModal } from '@ally/metronome-ui';
import { space } from 'styled-system';
import { isAfterDeliverOnDate } from '../utils';
import TimelineTracker from '../TimelineTracker';
import StatusModalDescription from './StatusModalDescription';
import StatusModalDetails from './StatusModalDetails';
var StyledTextHeading = styled(TextHeading)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    color: ", ";\n  "])), space, colors.plum);
});
function getTitle(title) {
    switch (title) {
        case 'WireTransfer':
            return 'Wire Transfer';
        case 'CheckOrder':
            return 'Check Order';
        default:
            return 'Transfer';
    }
}
function getTriggerContent(_a) {
    var currentStatus = _a.currentStatus, deliverOnDate = _a.deliverOnDate, title = _a.title;
    var isAch = title === 'ACHTransfer';
    var useDelivered = isAch && isAfterDeliverOnDate(deliverOnDate);
    switch (currentStatus) {
        case 'Confirmed':
            return 'Ordered';
        case 'InProcess':
            // eslint-disable-next-line no-nested-ternary
            return useDelivered ? 'Delivered' : isAch ? 'Processing' : 'Ordered';
        case 'VerificationRequired':
            return 'Needs Attention';
        case 'Completed':
        case 'Posted':
            return 'Delivered';
        default:
            return currentStatus;
    }
}
var Trigger = function (_a) {
    var event = _a.event;
    var showModal = useModal().showModal;
    var activityName = event.activityName, eventModelData = event.eventModelData, statuses = event.statuses;
    var currentStatus = statuses[0].status;
    var deliverOnDate = eventModelData.deliverOnDate;
    var statusTrackerType = activityName === 'InternalTransfers'
        ? 'Internal Transfers'
        : getTitle(activityName);
    var triggerContent = getTriggerContent({
        currentStatus: currentStatus,
        deliverOnDate: deliverOnDate,
        title: activityName,
    });
    var withAllyTMContent = "".concat(statusTrackerType.split(' ')[0], "-").concat(triggerContent.split(' ').join('-'));
    var onClick = function () {
        showModal();
        // Tracking modal for analytics
        if (window.allytm) {
            ;
            window.allytm.event('modalView', "AOS:Status Tracker:".concat(statusTrackerType, ":").concat(currentStatus), {
                treatAsPageview: true,
                statusTrackerType: statusTrackerType,
                statusTrackerStatus: "".concat(currentStatus),
            });
        }
    };
    return (React.createElement(Button, { variant: "link", text: triggerContent, onClick: onClick, withAllyTM: withAllyTMContent }));
};
var headingRef = React.createRef();
export var ModalContent = function (_a) {
    var event = _a.event, isStandaloneModal = _a.isStandaloneModal;
    var activityName = event.activityName;
    return (React.createElement(React.Fragment, null,
        !isStandaloneModal && (React.createElement(StyledTextHeading, { tag: "h1", size: "md", mb: "md", pr: "lg", tabIndex: -1, ref: headingRef }, getTitle(activityName))),
        React.createElement(TimelineTracker, { event: event }),
        React.createElement(StatusModalDescription, { event: event, isStandaloneModal: isStandaloneModal }),
        React.createElement(StatusModalDetails, { event: event })));
};
var StatusModal = function (_a) {
    var event = _a.event, _b = _a.isStandaloneModal, isStandaloneModal = _b === void 0 ? false : _b;
    return (React.createElement(Modal, { ref: headingRef, trigger: React.createElement(Trigger, { event: event }), content: React.createElement(ModalContent, { event: event, isStandaloneModal: isStandaloneModal }), height: "auto" }));
};
export default StatusModal;
var templateObject_1;
//# sourceMappingURL=index.js.map